import React, { FC } from 'react';
import { Flex, Button, Text, FlexProps, TextProps } from '@chakra-ui/react';
import { PlusToXRotatingIcon } from '@olo-web/components/atoms/PlusToXRotatingIcon';
import { useScreenSizeState } from '@olo-web/client-state';

interface I extends FlexProps {
  label: string;
  onClick: () => void;
  isOpen?: boolean;
  labelProps?: TextProps;
  hideIcon?: boolean;
}

export const AddButtonWithIcon: FC<I> = (props) => {
  const { label, onClick, isOpen, labelProps, hideIcon, ...rest } = props;
  const { isMdDown } = useScreenSizeState();

  return (
    <Flex
      isFullWidth={isMdDown}
      as={Button}
      type="button"
      variant="ghost"
      onClick={onClick}
      align="center"
      justify={{
        base: 'space-between',
      }}
      px={2}
      {...rest}
    >
      <Text
        textStyle="pBold"
        fontSize="0.9rem"
        transition="0.3s"
        transitionTimingFunction="ease-out"
        textAlign="left"
        justifySelf="flex-start"
        flex={isOpen ? 1 : 0}
        {...labelProps}
      >
        {label}
      </Text>
      {!hideIcon && (
        <PlusToXRotatingIcon isPlus={!isOpen} justifySelf="flex-end" ml={3} display="inline-flex" />
      )}
    </Flex>
  );
};
